module.exports = __webpack_public_path__ + "static/img/4.fa089fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/4.png
// module id = QbKv
// module chunks = 0